import DistrictManagement from '@/components/admin/DistrictManagement'

const AdminDistrictManagement = () => {
  return <DistrictManagement />
}

export default AdminDistrictManagement